(function () {
  "use strict";

  GroupRemoveRestrictionTrainerCtrl.$inject = ['$scope', '$modalInstance'];
  angular
    .module('trainerWebApp.modals')
    .controller('GroupRemoveRestrictionTrainerCtrl', GroupRemoveRestrictionTrainerCtrl);

  function GroupRemoveRestrictionTrainerCtrl($scope, $modalInstance) {
    $scope.modal = {
      content: 0,
      permissions: $scope.selectedTrainer.permissions.toLowerCase(),
      status: '',
      confirmed: false
    };
    $scope.forceCloseDropDown(); //close select2dropdown

    $scope.setup = {
      title: 'Confirm allowing access to all users. ',
      message: 'Removing the group restriction for this ' + $scope.modal.permissions + ' allows them to access all users. <br><br> Give them permissions for another group to restrict their access.',
      buttons: [
        {label: 'Cancel', cssClass: 'btn-general', result: 'dismiss'},
        {label: 'Allow', cssClass: 'btn-primary', result: 'continue'}
      ]
    };

    $scope.close = function (result) {
      if (result == 'continue') {
        $scope.modal.status = 'saving';
        $scope.modal.confirmed = true;
        $modalInstance.close();
      }
      else
        $modalInstance.dismiss(result);
    };
  }

})();
